import { render, staticRenderFns } from "./RouterMeta.vue?vue&type=template&id=38ae8140&scoped=true&"
import script from "./RouterMeta.vue?vue&type=script&lang=js&"
export * from "./RouterMeta.vue?vue&type=script&lang=js&"
import style0 from "./RouterMeta.vue?vue&type=style&index=0&id=38ae8140&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ae8140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ae8140')) {
      api.createRecord('38ae8140', component.options)
    } else {
      api.reload('38ae8140', component.options)
    }
    module.hot.accept("./RouterMeta.vue?vue&type=template&id=38ae8140&scoped=true&", function () {
      api.rerender('38ae8140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/router/RouterMeta.vue"
export default component.exports